{
  "actionbar.actions": "Akcie",
  "actionbar.actionsAvailable": "Dostupné akcie.",
  "actionbar.clearSelection": "Vymazať výber",
  "actionbar.selected": "{count, plural, =0 {Žiadne vybraté položky} other {Počet vybratých položiek: #}}",
  "actionbar.selectedAll": "Všetky vybraté položky",
  "breadcrumbs.more": "Ďalšie položky",
  "button.pending": "čakajúce",
  "combobox.noResults": "Žiadne výsledky",
  "contextualhelp.help": "Pomoc",
  "contextualhelp.info": "Informácie",
  "dialog.alert": "Upozornenie",
  "dialog.dismiss": "Zrušiť",
  "dropzone.replaceMessage": "Presuňte súbor, ktorý chcete nahradiť",
  "inlinealert.informative": "Informácie",
  "inlinealert.negative": "Chyba",
  "inlinealert.notice": "Upozornenie",
  "inlinealert.positive": "Úspech",
  "label.(optional)": "(nepovinné)",
  "label.(required)": "(povinné)",
  "menu.moreActions": "Ďalšie akcie",
  "notificationbadge.indicatorOnly": "Nová aktivita",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Vybrať…",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.loading": "Načítava sa...",
  "table.loadingMore": "Načítava sa viac...",
  "table.resizeColumn": "Zmeniť veľkosť stĺpca",
  "table.sortAscending": "Zoradiť vzostupne",
  "table.sortDescending": "Zoradiť zostupne",
  "tag.actions": "Akcie",
  "tag.hideButtonLabel": "Zobraziť menej",
  "tag.noTags": "Žiadne",
  "tag.showAllButtonLabel": "Zobraziť všetko ({tagCount, number})",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}
